module.exports = __webpack_public_path__ + "img/icon_city4.a4a54175.png";